export const INVALID_FORM_MESSAGE = 'The form is invalid.';
export const INVALID_FORM_GENERIC_MESSAGE = 'The form is invalid. Please check all fields.';
export const INVALID_FORM_MANY_FIELDS_MESSAGE =
  'The form is invalid. Please check all required fields (see console for details).';
export const INVALID_FORM_INLINE_FIELDS_THRESHOLD = 3;
export const INVALID_FORM_REQUIRED_FIELDS_PREFIX = 'The form is invalid. Please fill in the following required fields:';
